
import { useEffect, useState, useRef } from 'react';

import { lbbConfig } from './config';
import EImage from './assets/img/image.svg';
import EAudio from './assets/img/audio.svg';
import EVideo from './assets/img/video.svg';
import Default from './Components/layout/Default';
import MasonryLayout from './Components/layout/Masonry';
import Slider from './Components/layout/Slider';

const Lightbox = ({ ContentArea, attributes, isBackend = false, custom, id, Modal, index = 0 }) => {
	const { lightboxType, items, layout, columns, button, galleryIcon, popupOptions, popupIconLeft, popupIconMiddle, popupIconRight, thumb, slideShow, options, controls } = attributes;
	const { mixAllData } = popupOptions;
	const [isOpen, setOpen] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const containerRef = useRef();

	// funcyapps feature
	useEffect(() => {
		lbbConfig(id, popupIconLeft, popupIconMiddle, popupIconRight, thumb, slideShow, options, controls);

	}, [id, popupIconLeft, popupIconMiddle, popupIconRight, thumb, slideShow, options, controls]);

	const filteredItems = 'button' === lightboxType ? [items[0]] : items;

	const ButtonContent = () => <>
		{button.icon?.class && <i className={`icon ${button.icon?.class} `}></i>}
		<span>{button.text}</span>
	</>
	// check lightboxType
	if (!lightboxType) {
		return false
	}

	useEffect(() => {
		if (layout === 'default') {
			const lightBoxElement = document.querySelector(`#${id} .lbbLightBox`);
			if (lightBoxElement) {
				lightBoxElement?.style.setProperty('height', 'auto');
			}
		}
	}, [layout, id]);

	useEffect(() => {
		if (layout === 'default' || layout === 'masonry') {
			const Elements = document.querySelector(`#${id} .f-thumbs`);

			if (Elements) {
				Elements.style.display = 'none';
			}
		}
	}, [layout]);


	const globalProps = {
		attributes, filteredItems, mixAllData, id, EImage, ButtonContent, EAudio, EVideo, galleryIcon, setActiveIndex, isOpen, custom, isBackend, activeIndex, ContentArea, Modal, setOpen
	}

	const masonryProps = {
		...globalProps,
		containerRef
	}

	return <div ref={containerRef} className={` ${lightboxType === 'gallery' ? `lbbLightBox ${layout} columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}` : 'lbbLightBox llbButton'}`} id={`lightbox-${index}`}>
		{layout === 'masonry' ? <MasonryLayout {...masonryProps} /> : layout === 'slider' ? <Slider {...globalProps} /> : <Default {...globalProps} />}
	</div>
}
export default Lightbox;
